import API from '../api'
import convertPagableData from '../convertPagableData'
import postUrl from './paths'

export const getAllTenderBookUsers = (filters) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { ...filters, apiName: 'GET_Tender_users' })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getTenderBookUserById = (userId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { userId, apiName: 'GET_User' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// User 360 / analytics payload backing the Tenderbook user detail tabs.
export const getTenderBookUserAnalytics = (userId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { userId, apiName: 'GET_user_analytics' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const createTenderUserSubscription = (payload) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, { ...payload }, { apiName: 'POST_Admin_subscription' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const editTenderUser = (payload, userId, mobileNo) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, { ...payload }, { mobileNo, userId, apiName: 'PUT_Admin_user' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Saves the admin follow-up status and comments for a Tenderbook user.
export const updateTenderUserFollowUp = (payload, userId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, { ...payload }, { userId, apiName: 'PUT_User_FollowUp' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Saves the admin follow-up status and comments for a Tenderbook lead.
export const updateTenderLeadFollowUp = (payload, leadId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, { ...payload }, { leadId, apiName: 'PUT_Lead_FollowUp' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllTenderMaster = (filters) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { ...filters, apiName: 'GET_Tender_master' })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getAllTenderBookLeads = (filters) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { ...filters, apiName: 'GET_Tender_leads' })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const editTenderMaster = (tenderMaster, mobileNo) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, { ...tenderMaster }, { mobileNo, apiName: 'PUT_Tender_master' })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getUserSubscriptions = (userId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { userId, status: 'ACTIVE', apiName: 'GET_User_subscription' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const cancelUserSubscription = (subscriptionId, userId) =>
	new Promise((resolve, reject) => {
		// tenderBook gateway only accepts POST; the operation is routed via `apiName`.
		API.post(postUrl.tenderbook, {}, { userId, subscriptionId, apiName: 'PUT_User_subscription' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Tenderbook companies (bidders) list; searchable by `pan` and `organisationName`.
export const getTenderBookCompanies = (filters) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { ...filters, apiName: 'GET_BidderDetail_Competitors' })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

// Updates the PAN on a Tenderbook bidder (company) profile.
export const updateTenderBookBidderPan = (bidderDetailId, pan) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { bidderDetailId, pan, apiName: 'PUT_BidderDetail_updatePan' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Merges the child bidder organisation into the parent one, matched by organisation name.
export const mergeTenderBookBidders = (parentOrgName, childOrgName) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, { child_org_name: childOrgName, parent_org_name: parentOrgName }, { apiName: 'POST_BidderDetails_merge' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Resolves an organisation's PAN to its Tenderbook bidder profile ({ bidder_name, bidder_detail_id }).
export const getTenderBookBidderByPan = (pan) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.tenderbook, {}, { pan, apiName: 'GET_BidderDetail_byPan' })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
